import Vue from 'vue'

let sleep = function (ms) {
  return new Promise(resolve => setTimeout(resolve, ms))
}

const plugin = {
  install() {
    Vue.sleep = sleep
    Vue.prototype.$sleep = sleep
  }
}

Vue.use(plugin)
